<template>
  <v-row class="ma-0 overflow-overlay">
    <v-col :sm="viewerOpened ? 8 : 12" v-if="!isViewerFullscreen" class="pa-0">
      <v-sheet class="overflow-y-auto pe-2 d-flex flex-column" height="100%">
        <div class="d-flex">
          <v-row class="ma-0">
            <v-col cols="6" class="ps-0">
              <v-sheet
                class="totalCard TMin"
                style="border-left: 4px solid var(--v-blue2-base)"
                :class="{ tminActive: totals.isTminActive }"
                :color="
                  totals.isTminActive ? 'blue2' : $vuetify.theme.isDark ? '#4C4C4C33' : '#fff'
                "
                @click="toggleActive('Tmin')">
                <div class="d-flex">
                  <div class="d-flex align-center justify-center">
                    <div
                      class="rounded-pill iconContainer mx-2"
                      :style="{
                        'background-color': totals.isTminActive ? '#FFFFFF0D' : '#3377a70d',
                      }">
                      <img
                        v-if="totals.isTminActive"
                        width="35"
                        height="35"
                        src="@Assets/svgs/file_white.svg"
                        alt="tab icon" />
                      <img
                        v-else
                        width="35"
                        height="35"
                        src="@Assets/svgs/file.svg"
                        alt="tab icon" />
                    </div>
                  </div>
                  <div class="flex-grow-1 d-flex flex-column">
                    <v-card-title class="d-flex justify-space-between">
                      <span
                        class="font-weight-bold"
                        style="color: var(--v-grey-500-base)"
                        :class="{ 'white--text': totals.isTminActive && !$vuetify.theme.isDark }"
                        >Tmin</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            :color="
                              totals.isTminActive
                                ? $vuetify.theme.isDark
                                  ? 'black'
                                  : 'white'
                                : 'blue'
                            "
                            v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                      <span
                        class="totalResult"
                        :class="{ 'white--text': totals.isTminActive && !$vuetify.theme.isDark }">
                        {{ TMinSummary }}
                      </span>
                    </v-card-text>
                  </div>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="6" class="pe-0">
              <v-sheet
                class="totalCard RemainingLife"
                style="border-left: 4px solid var(--v-purple-base)"
                :class="{ remainingLifeActive: totals.isRemainingLifeActive }"
                :color="
                  totals.isRemainingLifeActive
                    ? 'purple'
                    : $vuetify.theme.isDark
                    ? '#4C4C4C33'
                    : '#fff'
                "
                @click="toggleActive('Remaining Life')">
                <div class="d-flex">
                  <div class="d-flex align-center justify-center">
                    <div
                      class="rounded-pill iconContainer mx-2"
                      :style="{
                        'background-color': totals.isRemainingLifeActive
                          ? '#FFFFFF0D'
                          : '#665b9b0d',
                      }">
                      <img
                        v-if="totals.isRemainingLifeActive"
                        width="35"
                        height="35"
                        src="@Assets/svgs/sand_clock_white.svg"
                        alt="tab icon" />
                      <img
                        v-else
                        width="35"
                        height="35"
                        src="@Assets/svgs/sand_clock.svg"
                        alt="tab icon" />
                    </div>
                  </div>
                  <div class="flex-grow-1 d-flex flex-column">
                    <v-card-title class="d-flex justify-space-between">
                      <span
                        class="font-weight-bold"
                        style="color: var(--v-grey-500-base)"
                        :class="{
                          'white--text': totals.isRemainingLifeActive && !$vuetify.theme.isDark,
                        }"
                        >Remaining life is<v-icon
                          class="font-weight-bold text-h4"
                          :dark="totals.isRemainingLifeActive"
                          >mdi-chevron-left</v-icon
                        >5 years</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            :color="
                              totals.isRemainingLifeActive
                                ? $vuetify.theme.isDark
                                  ? 'black'
                                  : 'white'
                                : 'purple'
                            "
                            v-bind="attrs"
                            v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                      <span
                        class="totalResult"
                        :class="{
                          'white--text': totals.isRemainingLifeActive && !$vuetify.theme.isDark,
                        }">
                        {{ RemainingSummary }}
                      </span>
                    </v-card-text>
                  </div>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </div>

        <dashboard-grid
          id="thicknessDashboardGrid"
          gridName="thickness"
          ref="dashboardGrid"
          class="flex-grow-1"
          :viewerOpened="viewerOpened"
          @openViewer="openViewer"
          :selectedFilters="selectedFilters" 
          :selectedRowsData.sync="selectedRowsData"
          :coloredInspections.sync="coloredInspections"></dashboard-grid>
      </v-sheet>
    </v-col>
    <v-col
      :cols="isViewerFullscreen ? '12' : '4'"
      v-show="viewerOpened"
      class="pb-0 h-100 overflow-overlay"
      :class="{ absoluteViewer: isViewerFullscreen }">
      <viewers-section
        ref="viewersSection"
        :hide360View="true"
        :viewerTab.sync="viewerTab"
        @closeViewersSection="closeInspectViewer"
        @toggleFullscreen="toggleFullscreen">
      </viewers-section>
    </v-col>
  </v-row>
</template>
<script>
  import { ForgeInspection } from '@/scripts/js/forgeModels';
  import DashboardGrid from '../components/DashboardGrid.vue';
  import ViewersSection from '../components/ViewersSection.vue';
  import { log, error } from '@/utils/debugLogger';

  export default {
    name: 'ThicknessDashboard',
    data() {
      return {
        viewerTab: '3D View',
        isViewerFullscreen: false,
        totals: {
          isTminActive: false,
          isRemainingLifeActive: false,
        },
      };
    },
    components: {
      DashboardGrid,
      ViewersSection,
    },
    computed: {
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
      viewer() {
        return this.$store.state.viewer;
      },
      isAMIS() {
        return !!this.$store.state.forgeSettings?.isAMIS;
      },
      TMinSummary() {
        return this.$store.getters.GET_TMIN;
      },
      RemainingSummary() {
        return this.$store.getters.GET_REMAINING_LIFE;
      },
      generalFilters: {
        get() {
          return this.$store.getters['DASHBOARD_FILTERS/GET_FILTERS'];
        },
        set(val) {
          this.$store.commit('DASHBOARD_FILTERS/SET_FILTERS', val);
        },
      },
      selectedFilters() {
        return {
          checkMinThickness: this.checkMinThickness,
          checkRemainingLife: this.checkRemainingLife,
        }
      },
      checkMinThickness: {
        get() {
          return this.$store.getters['THICKNESS_DASHBOARD/GET_CHECK_MIN_THICKNESS'];
        },
        set(value) {
          this.$store.commit('THICKNESS_DASHBOARD/SET_CHECK_MIN_THICKNESS', value);
        },
      },
      checkRemainingLife: {
        get() {
          return this.$store.getters['THICKNESS_DASHBOARD/GET_CHECK_REMAINING_LIFE'];
        },
        set(value) {
          this.$store.commit('THICKNESS_DASHBOARD/SET_CHECK_REMAINING_LIFE', value);
        },
      },
      viewerOpened: {
        get() {
          return this.$store.getters['THICKNESS_DASHBOARD/GET_VIEWER_OPENED'];
        },
        set(value) {
          this.$store.commit('THICKNESS_DASHBOARD/SET_VIEWER_OPENED', value);
        },
      },
      coloredInspections: {
        get() {
          return this.$store.getters['THICKNESS_DASHBOARD/GET_COLORED_INSPECTIONS'];
        },
        set(value) {
          this.$store.commit('THICKNESS_DASHBOARD/SET_COLORED_INSPECTIONS', value);
        },
      },
      selectedRowsData: {
        get() {
          return this.$store.getters['THICKNESS_DASHBOARD/GET_SELECTED_ROWS_DATA'];
        },
        set(value) {
          this.$store.commit('THICKNESS_DASHBOARD/SET_SELECTED_ROWS_DATA', value);
        },
      },
    },
    activated() {
      if (this.viewerOpened) {
        this.openViewer();
      }
    },
    mounted() {
      // this.forgeService.loadInspectionTagsAdvanced('', false);
      this.$store.dispatch('GET_TMIN_SUMMARY', {
        ...this.selectedFilters,
        facilityId: this.$route.params.id,
      });
      this.$store.dispatch('GET_REMAINING_LIFE_SUMMARY', {
        ...this.selectedFilters,
        facilityId: this.$route.params.id,
      });
    },
    methods: {
      closeInspectViewer() {
        this.viewerOpened = false;
      },
      openViewer() {
        this.viewerOpened = true;
        this.handleViewerChange();
      },
      handleViewerChange() {
        if (this.viewerTab === '3D View') {
          this.handle3dViewer();
        } else if (this.viewerTab === '2D View') {
          this.handle2dViewer();
        }
      },
      handle3dViewer() {
        this.$refs.viewersSection.load3dViewer().then(() => {
          this.$refs.dashboardGrid.isolateSelectedInspection3d();
        });
      },
      handle2dViewer() {
        if (!this.viewerOpened) return;
        
        let selectedInspections = this.$refs.dashboardGrid.selectedColoredInspections;

        if (!Array.isArray(selectedInspections)) selectedInspections = [selectedInspections];

        if (selectedInspections.length === 0) {
          this.$dialog.notify.error('No inspection selected');
          return;
        }

        selectedInspections = selectedInspections.map((o) => {
          if (o instanceof ForgeInspection) {
            return o;
          } else {
            let e = Object.assign(new ForgeInspection(), o);
            e.parseContent();
            return e;
          }
        });

        this.handleIsolateMatchedInspections2d(selectedInspections);
      },
      async handleIsolateMatchedInspections2d(inspections) {
        let points = inspections.map((o) => o?.point).filter((o) => o);

        let levelsSet = new Set(points.map((o) => this.forgeService.getLevelContainsPoint(o)));

        let levels = Array.from(levelsSet).filter((o) => o);

        let level = levels.length == 1 ? levels[0] : this.$store.state.levels[0];

        if (levels.length > 1) {
          error('Multiple levels found', levels);
          this.$dialog.notify.warning('Multiple levels found');
        }

        this.$store.state.selectedLevel = level;

        if (!level?.planUrn) {
          error('Plan URN not found', level);
          this.$dialog.notify.error('Plan URN not found');
          this.$refs.viewersSection.viewerState.isLoading = false;
          return;
        }

        this.$refs.viewersSection.load2dViewer(level.planUrn).then(() => {
          // this.forgeService.zoomToPoints2D(points);
          this.forgeService.getLabels2DExtension().clear3DTags();
          this.forgeService.getLabels2DExtension().createHighlightingTags(inspections);
          this.$refs.viewersSection.viewerState.isLoading = false;
        });
      },
      toggleFullscreen(event) {
        this.isViewerFullscreen = event;
        this.$store.commit('SET_VIEW_1_TYPE', '3d');
        this.$store.commit('SET_IS_VIEW_1_VISIBLE', true);
        this.$store.commit('SET_IS_VIEW_2_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_3_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_4_VISIBLE', false);
        this.$router.push({
          name: 'facility',
          query: {},
        });
      },
      toggleActive(title) {
        if (title === 'Tmin') {
          this.totals.isTminActive = !this.totals.isTminActive;
          this.totals.isRemainingLifeActive = false;
          this.checkRemainingLife = false;
          this.checkMinThickness = this.totals.isTminActive;
        } else {
          this.totals.isRemainingLifeActive = !this.totals.isRemainingLifeActive;
          this.totals.isTminActive = false;
          this.checkMinThickness = false;
          this.checkRemainingLife = this.totals.isRemainingLifeActive;
        }
      },
    },
    watch: {
      viewerOpened() {
        this.$emit('viewerOpened', this.viewerOpened);
      },
      viewerTab: {
        handler: function () {
          this.handleViewerChange();
        },
      },
      selectedFilters: {
        handler: function () {
          log(`%cThickness Selected Filters Changes!`, 'color: #4CAF50; font-weight: bold;');
        },
        deep: true,
      },
      generalFilters: {
        handler: function (val) {
          this.$store.dispatch('GET_TMIN_SUMMARY', { ...val, facilityId: this.$route.params.id });
          this.$store.dispatch('GET_REMAINING_LIFE_SUMMARY', {
            ...val,
            facilityId: this.$route.params.id,
          });
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss">
  .customSearchBox {
    .v-input__control .v-input__slot {
      padding-right: 5px;
      .v-input__append-inner {
        margin-top: 5px !important;
        .v-input__icon--append {
          border-radius: 50%;
          background-color: var(--v-primary-base);
          width: 30px;
          height: 30px;
          i {
            color: var(--v-white-base);
          }
        }
      }
    }
  }

  .activeTab {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-white-base) !important;
  }

  .custom-tabs {
    .v-tab {
      color: var(--v-primary-base) !important;
    }
    .v-tab--active {
      color: inherit;
    }
  }
  .customBoxShadow {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
      0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .v-list-item::not {
    border-bottom: 1px solid var(--v-grey-500-lighten4);
  }
  .notSelectedChip {
    background-color: #edf2e8 !important;
    // background-color: var(--v-light-grey2-base) !important;
    // color: var(--v-primary-base) !important;
  }
  .selectedChip {
    background-color: #edf2e8 !important;
    color: var(--v-primary-base) !important;
    border: 2px solid var(--v-primary-base);
  }

  .option-input-wrapper input {
    width: 50px;
    height: 35px;
    border: none;
    padding: 0px;
    background-color: transparent;
  }
  .theme--dark .option-input-wrapper input {
    color: var(--v-bg_force_white-base);
  }

  .LastInspectionsToggle {
    & .v-btn {
      color: var(--v-primary-base) !important;
      text-transform: none !important;
      background-color: #edf2e8 !important;
      letter-spacing: normal !important;
      font-weight: 600;
      border: none;

      & i {
        color: var(--v-primary-base) !important;
      }

      &:hover:before {
        background-color: var(--v-primary-base);
      }

      &.v-btn--active {
        color: white !important;
        box-shadow: none !important;

        & i {
          color: white !important;
        }

        &:before {
          background-color: var(--v-primary-base);
          opacity: 1;
        }
      }
    }
  }

  .v-chip-custom {
    font-size: 11px;
    height: 27px;
    width: 27px;
    text-align: center;
    .v-chip__content {
      justify-content: center;
    }
  }
  .absoluteViewer {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
  }
  .totalCard {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05) !important;

    border-radius: 7px;
    cursor: pointer;
  }
  .RemainingLife {
    &:hover {
      background-color: #665b9b33 !important;
    }
  }
  .TMin {
    &:hover {
      background-color: #2f95dc33 !important;
    }
  }
  .tminActive {
    &:hover {
      background-color: #ecf1f5 !important;
    }
  }
  .remainingLifeActive {
    &:hover {
      background-color: #efeff5 !important;
    }
  }

  .totalResult {
    font-size: 24px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--v-grey-500-base);
  }
  .iconContainer {
    width: 54px;
    height: 54px;
    padding: 10px;
    gap: 10px;
    border-radius: 50px;
  }
</style>
